import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsEditRiskSettingsResolverErrorStatesEnum {
    GetOmsRiskParametersFailed = ErrorStateScheduleEnum.PanelAccountsEditRiskSettingsResolverErrorStatesStartIndex,
    GetOmsRiskParametersNotFound
}
